import { createStore } from 'satcheljs';
import type { SearchFilterOption } from 'owa-timestream-asset-search';
import { ObservableMap } from 'mobx';

export default createStore('spacesSearchViewStore', {
    currentSearchPivotKey: '',
    currentFilterKey: '',
    searchFilters: new ObservableMap<string, SearchFilterOption>(),
});
